import { ComponentProps, FC } from 'react';
import {
	StaticHeaderLayout,
	StaticHeaderLayoutItem,
	StaticHeaderLayoutKeyIndicators,
	StaticHeaderLayoutLeftSide,
	StaticHeaderLayoutRightSide,
} from '../StaticHeaderLayout';
import ButtonBack from '../../../../../../ReactSharedScripts/modules/detailPage/components/ButtonBack';
import TooltipBtn from '../../../../../../ReactSharedScripts/components/TooltipBtn';
import { ThemeStyle } from '../../../../../../ReactSharedScripts/utils/const';
import { MovingGradient } from '../../../../../../ReactSharedScripts/components/MovingGradient';
import { DetailPagePlaceholderCommentsButton } from '../../../../../../ReactSharedScripts/modules/detailPage/components/DetailPagePlaceholder/DetailPagePlaceholderCommentsButton';
import { NavigationRouteButtons } from '../../../../../../ReactSharedScripts/modules/detailPage/components/NavigationButtons';
import { DetailPageKeyIndicatorsPlaceholder } from '../../../../../../ReactSharedScripts/modules/detailPage/components/DetailPlaceholders/DetailPageKeyIndicatorsPlaceholder';
import { DetailPageHeaderTitlePlaceholder } from '../../../../../../ReactSharedScripts/modules/detailPage/components/DetailPagePlaceholder/DetailPageHeaderTitlePlaceholder';

type DetailPagePlaceholderHeaderProps = {
	hasComments?: boolean;
	commentsProps?: ComponentProps<typeof DetailPagePlaceholderCommentsButton>;
};

const DetailPagePlaceholderHeader: FC<DetailPagePlaceholderHeaderProps> = ({ hasComments, commentsProps }) => {
	return (
		<>
			<StaticHeaderLayout hasKeyIndicators>
				<StaticHeaderLayoutLeftSide stretch>
					<StaticHeaderLayoutItem>
						<ButtonBack
							size='small'
							disabled
						/>
					</StaticHeaderLayoutItem>
					<StaticHeaderLayoutItem stretch>
						<DetailPageHeaderTitlePlaceholder />
					</StaticHeaderLayoutItem>
				</StaticHeaderLayoutLeftSide>
				<StaticHeaderLayoutRightSide>
					<StaticHeaderLayoutItem>
						<TooltipBtn
							tooltip={null}
							tooltipTheme={ThemeStyle.Light}
							tooltipPosition='bottom'
							tooltipAlign='end'
							autoClose
							styledButton
							rounded
							disabled
						>
							<MovingGradient
								height='16px'
								width='80px'
							/>
						</TooltipBtn>
					</StaticHeaderLayoutItem>
					{hasComments && (
						<StaticHeaderLayoutItem>
							<DetailPagePlaceholderCommentsButton {...commentsProps} />
						</StaticHeaderLayoutItem>
					)}
					<StaticHeaderLayoutItem>
						<NavigationRouteButtons
							prevPageUrl=''
							nextPageUrl=''
						/>
					</StaticHeaderLayoutItem>
				</StaticHeaderLayoutRightSide>
			</StaticHeaderLayout>
			<StaticHeaderLayoutKeyIndicators>
				<DetailPageKeyIndicatorsPlaceholder />
			</StaticHeaderLayoutKeyIndicators>
		</>
	);
};

export { DetailPagePlaceholderHeader };
